import { faUpRightFromSquare } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type FC } from 'react';
import { PriceLevel, PriceLevelSymbols } from '../../..';
import { type ResortPlaceRecommendation } from '../types';
import { RecommendationCard } from './RecommendationCard';

interface Props {
  readonly resortPlace: ResortPlaceRecommendation;
}

const asPriceLevel = (s: string | null): PriceLevel | null => {
  switch (s) {
    case 'Inexpensive':
      return PriceLevel.Inexpensive;
    case 'Moderate':
      return PriceLevel.Moderate;
    case 'Expensive':
      return PriceLevel.Expensive;
    default:
      return null;
  }
};

const tagify = (className: string, labels: readonly string[] | null) =>
  (labels ?? [])
    .filter((s) => s.trim().length)
    .map((label) => ({
      className,
      label,
    }));

export const ResortPlaceCard: FC<Props> = ({
  resortPlace: {
    name,
    website_link: websiteLink,
    image_link: imageLink,
    description,
    price_level: priceLevel,
    tags_list: tagsList,
    hours_today: hoursToday,
    best_for_list: bestForList,
    location,
    map_link: mapLink,
    cost,
    menu_link: menuLink,
    virtual_tour_link: virtualTourLink,
  },
}) => (
  <RecommendationCard
    image={imageLink ? { uri: imageLink, altText: 'TBD' } : null}
    name={name}
    url={websiteLink}
    subtitleContent={
      asPriceLevel(priceLevel) || menuLink ? (
        <span className={'icon-text'}>
          {asPriceLevel(priceLevel) ? <PriceLevelSymbols priceLevel={asPriceLevel(priceLevel)} /> : null}
          {menuLink ? (
            <a href={menuLink} target={'_blank'} rel={'nofollow'}>
              <span>Menu</span>
              <span className={'icon'}>
                <FontAwesomeIcon icon={faUpRightFromSquare} />
              </span>
            </a>
          ) : null}
        </span>
      ) : null
    }
    tags={tagify('is-primary', tagsList).concat(tagify('is-info', bestForList))}
    hoursToday={hoursToday}
    description={description}
    location={location ? { name: location, mapLink } : null}
    cost={cost}
    virtualTourLink={virtualTourLink && virtualTourLink.trim() !== '' ? virtualTourLink : null}
  />
);
ResortPlaceCard.displayName = 'ResortPlaceCard';
